module.exports = __webpack_public_path__ + "static/quartier_A-4584a96d059e1b76d3874a9ae58cc333.png";